export default "/images/caret-down.svg?dbf503a09b5d9d0066499daa8c362081";